var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"uploader",attrs:{"name":"image","action":_vm.action,"headers":_vm.headers,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[_vm._t("default",function(){return [_c('el-button',[_vm._v(_vm._s(_vm.$t('public64')))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }